module.exports = __webpack_public_path__ + "img/porto-alegre.bdc665d3.jpg";